"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExposeDataManager = void 0;
var inversify_1 = require("inversify");
var ExposeDataManager = /** @class */ (function () {
    function ExposeDataManager() {
        this.observeItems = [];
        this.exposingItems = [];
        this.exposedItems = [];
        this.currentExposes = [];
    }
    ExposeDataManager.prototype.addObserveItem = function (item) {
        this.observeItems.push(__assign({}, item));
    };
    ExposeDataManager.prototype.findObserveItem = function (target) {
        return this.observeItems.find(function (item) { return item.target === target; });
    };
    ExposeDataManager.prototype.resetObserveItem = function () {
        this.observeItems = [];
    };
    ExposeDataManager.prototype.addExposingItem = function (item) {
        this.exposingItems.push(__assign({}, item));
        // // 重组曝光元素相对位置
        // this.exposingItems.forEach((item, index) => {
        //   item.relativePosition = index + 1;
        // });
    };
    ExposeDataManager.prototype.addExposedItem = function (item) {
        this.exposedItems.push(item);
    };
    ExposeDataManager.prototype.updateExposedItems = function (items) {
        var _this = this;
        items.forEach(function (item) {
            if (!item.target) {
                return;
            }
            var index = _this.findExposedItemIndex(item.target);
            if (index > -1) {
                _this.exposedItems[index] = __assign(__assign({}, _this.exposedItems[index]), item);
            }
        });
    };
    ExposeDataManager.prototype.getExposingItems = function () {
        return this.exposingItems;
    };
    ExposeDataManager.prototype.removeExposingItem = function (index) {
        this.exposingItems.splice(index, 1);
    };
    ExposeDataManager.prototype.resetExposingItems = function () {
        this.exposingItems = [];
    };
    ExposeDataManager.prototype.getExposedItems = function () {
        return this.exposedItems;
    };
    ExposeDataManager.prototype.removeExposedItem = function (index) {
        this.exposedItems.splice(index, 1);
    };
    ExposeDataManager.prototype.resetExposedItems = function () {
        this.exposedItems = [];
    };
    ExposeDataManager.prototype.findExposingItem = function (element) {
        return this.exposingItems.find(function (item) { return item.target === element; });
    };
    ExposeDataManager.prototype.findExposedItem = function (element) {
        return this.exposedItems.find(function (item) { return item.target === element; });
    };
    ExposeDataManager.prototype.findExposingItemIndex = function (element) {
        return this.exposingItems.findIndex(function (item) { return item.target === element; });
    };
    ExposeDataManager.prototype.findExposedItemIndex = function (element) {
        return this.exposedItems.findIndex(function (item) { return item.target === element; });
    };
    ExposeDataManager.prototype.addCurrentExpose = function (item) {
        this.currentExposes.push(item);
    };
    ExposeDataManager.prototype.getCurrentExposes = function () {
        return this.currentExposes;
    };
    ExposeDataManager.prototype.setCurrentExposes = function (items) {
        this.currentExposes = items;
    };
    ExposeDataManager.prototype.setClickedExposed = function (item) {
        this.clickedExposed = item;
    };
    ExposeDataManager.prototype.getClickedExposed = function () {
        return this.clickedExposed;
    };
    ExposeDataManager = __decorate([
        (0, inversify_1.injectable)()
    ], ExposeDataManager);
    return ExposeDataManager;
}());
exports.ExposeDataManager = ExposeDataManager;
